import { Button, Header, LoadingSpinner, SelectInput } from '@components/Generic'
import type { SelectOption } from '@components/Generic/SelectInput/SelectInput'
import type { MultiValue, SingleValue } from 'react-select'
import { observer } from 'mobx-react'
import { useContext, useState } from 'react'
import { StoreContext } from '@store/Root.store'
import idin from '../assets/idin_logo.png'

const banksList = [
  {
    country: 'Nederland',
    issuers: [
      {
        name: 'Currence Issuer',
        id: 'CURRNL2A',
      },
      {
        name: 'Rabobank iDIN issuer simulatie',
        id: 'RABONL2U',
      },
    ],
  },
]

export const BankSelectionPage = observer(() => {
  const store = useContext(StoreContext)

  const { bankSelectionPage: trans } = store.TranslationsState.translations

  const banksOptions = banksList
    .flatMap((country) => country.issuers)
    .map((item) => ({ value: item.id, label: item.name }))

  const [bank, setBank] = useState<SelectOption | null>(null)
  const [bankId, setBankId] = useState(-1)
  const [loading, setLoading] = useState(false)

  const handleProceed = async () => {
    setLoading(true)

    setTimeout(() => {
      store.ScenarioState.nextPage()
    }, 2000)
  }

  const bankChangeHandler = (e: SingleValue<SelectOption> | MultiValue<SelectOption>) => {
    const option = e as SelectOption | null // BankSelection is always single-select
    if (!option) return
    const index = banksOptions.findIndex((item) => item.value === option.value)
    setBank(option)
    setBankId(index)
  }

  return (
    <div className="page-container">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <div className="layout__margined m-0-0-50">
            <div className="ikano__center-liner">
              <img width="100" src={idin} alt="iDIN logo" />
            </div>
          </div>
          <Header>{trans.header}</Header>

          <div className="generic__select-holder">
            <div className="generic__label">{trans.label}</div>
            <SelectInput
              options={banksOptions}
              value={banksOptions[bankId]}
              onChange={(e) => bankChangeHandler(e)}
            />
          </div>

          <div className="layout__content-container-bottom-upload">
            <div className="layout__content-container-bottom-left" />
            <Button onClick={() => handleProceed()} disabled={!bank}>
              <>
                <span className="generic__button-text">{trans.proceed}</span>
              </>
            </Button>
          </div>
        </>
      )}
    </div>
  )
})
